/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/8/2016
 * Time: 9:58 AM
 */
export default {
  addNote: {
    id: 'note.addNote',
    description: 'Message for adding a note',
    defaultMessage: 'New Note'
  },
  newNoteTitle: {
    id: 'note.newNote.title',
    description: 'Title for adding a note',
    defaultMessage: 'Enter a note:'
  }
};



/** WEBPACK FOOTER **
 ** ./src/main/js/notes/i18n/MessageDefinitions.js
 **/